var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 19.664,
    viewBox: "0 0 24.001 19.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "feedback",
    d: "M20,3H4A4,4,0,0,0,0,7v8a4,4,0,0,0,4,4H6.923l3.749,3.157a2.011,2.011,0,0,0,1.337.507A1.94,1.94,0,0,0,13.3,22.18L17.149,19H20a4,4,0,0,0,4-4V7a4,4,0,0,0-4-4ZM7.822,10.876l-1.183.964.489,1.49a.5.5,0,0,1-.169.553.5.5,0,0,1-.578.023L5,13.009l-1.354.906a.5.5,0,0,1-.755-.566l.47-1.508-1.189-.967A.5.5,0,0,1,2.5,9.993H4L4.53,8.5a.5.5,0,0,1,.938,0L6,9.993H7.5a.5.5,0,0,1,.322.883Zm7,0-1.183.964.489,1.49a.5.5,0,0,1-.169.553.5.5,0,0,1-.578.023L12,13.009l-1.354.906a.5.5,0,0,1-.755-.566l.47-1.508-1.189-.967A.5.5,0,0,1,9.5,9.993H11L11.53,8.5a.5.5,0,0,1,.938,0L13,9.993h1.5a.5.5,0,0,1,.322.883Zm7,0-1.183.964.489,1.49a.5.5,0,0,1-.169.553.5.5,0,0,1-.578.023L19,13.009l-1.354.906a.5.5,0,0,1-.755-.566l.47-1.508-1.189-.967a.5.5,0,0,1,.323-.881H18L18.53,8.5a.5.5,0,0,1,.938,0L20,9.993h1.5a.5.5,0,0,1,.322.883Z",
    transform: "translate(0 -3)",
    fill: "#136ad0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.5395e0ba17f870c6a78d79e4adb4b911.svg";
export { ForwardRef as ReactComponent };